import { http } from '@/core/helpers/http.helper';
import { HitExistsPayload, HitExistsResponse } from './exists.interface';

export class ExistsService {
   async checkIfExist(payload: HitExistsPayload) {
      const response = await http.post<HitExistsResponse>(`/hits/exists`, payload);
      return response.data;
   }
}
